<template>
  <div
    class="lg:mx-auto md:mx-12 mx-6  overflow-hidden lg:max-w-none lg:flex mt-12"
  >
    <div
      class="bg-white px-6 border-8 border-vectric rounded-t-2xl rounded-br-2xl py-8 lg:flex-shrink-1 lg:p-12 lg:w-2/3"
    >
      <h3 class="text-lg md:text-xl font-bold text-gray-900 md:text-3xl">
        {{ session.title }}
      </h3>
      <div v-if="session.youtubeEmbedURL && showStreams">
        <div class="video">
          <div class="mx-auto embed-container">
            <iframe
              :src="session.youtubeEmbedURL"
              class="w-full"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
      <div class="mx-auto mt-8" v-else>
        <img :src="previewImage" class="shadow-lg mx-auto" />
      </div>

      <p class="text-base leading-6 text-gray-500 prose mt-8">
        <standard-block-content
          :blocks="session.description"
        ></standard-block-content>
      </p>
      <!--<div class="mt-8">
        <topic-grid :session="session" :color="topicColor"></topic-grid>
      </div>-->
      <div class="mt-8" v-if="hasTutorials">
        <tutorial-videos :session="session"></tutorial-videos>
      </div>
      <div class="mt-10">
        <session-compatibility-block
          :session="session"
        ></session-compatibility-block>
      </div>
    </div>
    <div
      class="py-2 px-6 text-center lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-start lg:px-12 lg:w-1/3"
    >
      <details-side-bar :session="session" />
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";
import DetailsSideBar from "./DetailsSideBar";
import SessionCompatibilityBlock from "./SessionCompatibilityBlock";
import StandardBlockContent from "./StandardBlockContent";
import TutorialVideos from "./TutorialVideos";
import { colorFromSession } from "../utils/colorFromSession";

export default {
  name: "PreviewSessionPage",
  components: {
    TutorialVideos,
    StandardBlockContent,
    SessionCompatibilityBlock,
    DetailsSideBar
  },
  props: {
    session: {
      type: Object,
      required: true
    },
    showStreams: {
      type: Boolean,
      required: true,
      defaultValue: true
    }
  },
  computed: {
    hasTutorials() {
      const tutorials = this.session.tutorials || [];
      return tutorials.length > 0;
    },
    previewImage() {
      return sanityImageBuilder
        .image(this.session.previewImage)
        .width(400)
        .url();
    },
    topicColor() {
      return colorFromSession(this.session);
    },
    hasRelatedTutorials() {
      if (this.session.tutorials !== "undefined") {
        return false;
      }
      if (this.session.tutorials.length > 0) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped>
.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
